import React, { FC, SVGProps } from 'react';

// Line icons drawn in currentColor so every step can tint them from CSS.

type IconProps = SVGProps<SVGSVGElement>;

const base: IconProps = {
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.7,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
};

export const CardIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <rect x="3" y="5.5" width="18" height="13" rx="3" />
        <path d="M3 10h18M7 14.5h3" />
    </svg>
);

export const RegisterIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M4 9.5 5.2 5h13.6L20 9.5" />
        <path d="M4 9.5h16v2a2.5 2.5 0 0 1-5 0 2.5 2.5 0 0 1-3 0 2.5 2.5 0 0 1-3 0 2.5 2.5 0 0 1-5 0v-2Z" />
        <path d="M5.5 13.5V19h13v-5.5M10 19v-4h4v4" />
    </svg>
);

export const RoomIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M3 18v-7.5M3 14h18v4M21 14v-2.5a2 2 0 0 0-2-2h-8V14" />
        <path d="M3 10.5V7a1.5 1.5 0 0 1 1.5-1.5h15A1.5 1.5 0 0 1 21 7v2.5" />
        <circle cx="7" cy="11" r="1.6" />
    </svg>
);

export const CheckIcon: FC<IconProps> = (props) => (
    <svg {...base} strokeWidth={2.2} {...props}>
        <path d="m5 12.5 4.5 4.5L19 7.5" />
    </svg>
);

export const CrossIcon: FC<IconProps> = (props) => (
    <svg {...base} strokeWidth={2.2} {...props}>
        <path d="m6.5 6.5 11 11M17.5 6.5l-11 11" />
    </svg>
);

export const ClockIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M12 7.5V12l3 2" />
    </svg>
);

export const LockIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <rect x="5" y="10.5" width="14" height="10" rx="2.5" />
        <path d="M8.5 10.5V8a3.5 3.5 0 0 1 7 0v2.5" />
    </svg>
);
